import React from 'react';

export default function ConnectionErrorPage() {
  return (
    <div className="page">
      <h1>Connection error</h1>
      <p className="muted">
        There was an error connecting to the server. Please try again later.
      </p>
    </div>
  );
}
